/* Subscription App addons */
document.addEventListener('DOMContentLoaded', function() {
  function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }
    
            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });
    
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    }

    waitForElm('.sealsubs-target-element').then((elm) => {
        var mitSubscription = document.querySelector('.sealsubs-target-element');
        var mitSubscriptionDiv = document.createElement('div');
    
        mitSubscriptionDiv.innerHTML = `
          <div>
          <h3> Deine Vorteile im Futterabo:</h3>
            <div class="mit-subscription-info">
              <ul>
                <li><strong>Ultimative Bequemlichkeit:</strong> <span>Futter wird regelmäßig und pünktlich direkt an deine Haustür geliefert</span></li>
                <li><strong>Spart Zeit & Geld:</strong> <span>Sichere dir 15% Rabatt auf jede Lieferung im Sparabo</span></li>
                <li><strong>Einzigartige Qualität:</strong> <span>Versorge deinen Hund kontinuierlich mit hochwertiger Nahrung.</span></li>
              </ul>
            </div>
          </div>
        `;
    
        mitSubscription.appendChild(mitSubscriptionDiv);
      });
});

